// Axios
import axios from 'axios';

// Configuration
import { BASE_URL, PAYMENT_SERVICE, SERVICE_VERSION, USER_SERVICE_CAPABILITIES_URL } from './configuration';
import { setSnackbar } from './generic-action';

const PAYMENT_SERVICE_URL = `${BASE_URL}/${PAYMENT_SERVICE}/${SERVICE_VERSION}`;

export const getLoanUserConsents = () =>
  axios.get(`${PAYMENT_SERVICE_URL}/users/consents`);

export const saveLoanUserConsent = (consentName) =>
  axios.post(`${PAYMENT_SERVICE_URL}/users/consents`, {
    consent: true,
    documentNames: ['DPN', 'TC'],
    name: consentName
  });

// Used on page load to check whether the logged-in user has already registered loan details.
export const getLoanUserRegistrationDetails = () =>
  axios.get(`${USER_SERVICE_CAPABILITIES_URL}/user/loan/details`);

// Registers the loan applicant's basic details before the consent/onboarding flow continues.
export const registerLoanUserDetails = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${USER_SERVICE_CAPABILITIES_URL}/user/loan/details`,
      payload
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message: error?.response?.data?.message || error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

// Returns [] when the user has no loan intent yet, else the list of existing intents.
export const getLoanIntents = () =>
  axios.get(`${USER_SERVICE_CAPABILITIES_URL}/user/loan/intent`);

// Pass {} to create a brand-new intent, or { loanIntentId } to resume an existing one.
export const createOrResumeLoanIntent = (payload = {}) =>
  axios.post(`${USER_SERVICE_CAPABILITIES_URL}/user/loan/intent`, payload);

export const getLoanIntentStatus = (loanIntentId) =>
  axios.get(`${USER_SERVICE_CAPABILITIES_URL}/user/loan/intent/${loanIntentId}/status`);